<template>
  <div class="container">

    <div class="top-wrapper">
      <!-- <div class="nav-item" id="left-nav-item" @click="goSetting">
        <img src="../../../assets/image/member/icon_setting_nor.png" class="nav-icon">
      </div> -->
      <div class="nav-item" id="right-nav-item" @click="goNews()">
        <img src="../../../assets/image/member/m-tz.png" class="nav-icon">
        <span v-if="0"></span>
      </div>
      <div class="top-info-wrapper">
        <div class="avatar-wrapper">
          <!-- <img class="avatar" v-bind:src="user.member_avatar + '?' + time"
            v-if="isOnline && user && user.member_avatar" /> -->
          <img class="avatar" src="../../../assets/image/member/favicon.png" />
        </div>
        <p class="nickname">{{ user.member_name }}</p>
        <!-- <p class="uid" @click="goProfileInfo">ID: {{ user.member_id }}</p> -->

        <!-- <div class="p level_name_wrapper">
          <div class='level_name'>
            <img src="../../../assets/image/member/usertopicon.png" class="img levelname-icon">
            {{ getlevelname }}
          </div>
        </div> -->

      </div>
      <div class="info-wrapper">
        <div class="info-item" @click="goAccount">
          <div class="item">{{ $t('USDT') }}</div>
          <div class="item price">${{ getAvailablePredeposit }}</div>
        </div>
        <div class="info-item" @click="goCommission(0)">
          <div class="item">{{ $t('Direct') }}</div>
          <div class="item price">$ {{ user.share_price }}</div>
        </div>
        <div class="info-item" @click="goCommission(1)">
          <div class="item">{{ $t('Indirect') }}</div>
          <div class="item price">$ {{ user.parent_share_price }}</div>
        </div>
        <!-- <div class="info-item" @click="goScoreList">
          <div class="item">积分</div>
          <div class="item price">{{ getScore }}</div>
        </div> -->
      </div>
    </div>

    <!-- <div class="banner" @click="gotobuy">
      <img src="../../../assets/image/home/gobuy.png" alt="gobuy">
    </div> -->

    <mt-swipe class="banner" style="height: 4.1rem;" :speed="600" :show-indicators="false">
      <mt-swipe-item>
        <img src="../../../assets/image/home/gobuy.png" @click="gotobuy" alt="gobuy">
      </mt-swipe-item>
      <!-- <mt-swipe-item>
        <img src="../../../assets/image/member/Recycle.png" @click="goGiftSave" alt="Recycle">
      </mt-swipe-item> -->
    </mt-swipe>

    <!-- <div class="order">
      <flex-line class="order-header" :is-link="true" @click.native="goOrder">
        <span>{{ $t('MyOrders') }}</span>
        <span slot="right">{{ $t('ViewAll') }}</span>
      </flex-line>
      <div class="order-wrapper">
        <index-order-item class="order-item" testAttr="MemberOrderList" id="state_new"
          :src="require('../../../assets/image/member/o0.png')" :title="$t('Unpaid')"
          :orderNumber="user.order_nopay_count">
        </index-order-item>
        <index-order-item class="order-item" testAttr="MemberOrderList" id="state_pay"
          :src="require('../../../assets/image/member/o1.png')" :title="$t('ToShip')"
          :orderNumber="user.order_noship_count">
        </index-order-item>
        <index-order-item class="order-item" testAttr="MemberOrderList" id="state_send"
          :src="require('../../../assets/image/member/o2.png')" :title="$t('ToReceive')"
          :orderNumber="user.order_noreceipt_count">
        </index-order-item>
        <index-order-item class="order-item" testAttr="MemberOrderList" id="state_noeval"
          :src="require('../../../assets/image/member/o3.png')" :title="$t('ToReview')"
          :orderNumber="user.order_noeval_count">
        </index-order-item>
      </div>
    </div> -->

    <!-- <flex-line class="order-header" :is-link="true" style="padding-top:0.5rem; margin-top:0;" @click.native="goBox">
      <span>{{ $t('MyBlindBox') }}</span>
      <span slot="right">{{ $t('ViewAll') }}</span>
    </flex-line>
    <div class="order-wrapper">
      <index-order-item class="order-item" testAttr="BlindBoxList" id="4"
        :src="require('../../../assets/image/member/icon_goods_nor.png')" :title="$t('WaitingDraw')"
        :orderNumber="box_dot.status_4">
      </index-order-item>
      <index-order-item class="order-item" testAttr="BlindBoxList" id="1"
        :src="require('../../../assets/image/member/icon_consignee_nor.png')" :title="$t('Opened')"
        :orderNumber="box_dot.status_1">
      </index-order-item>
    </div>
    <flex-line class="order-header" :is-link="true" style="padding-top:0.5rem; margin-top:0;" @click.native="goGiftSave">
      <span>{{ $t('GiftCard') }}</span>
      <span slot="right">{{ $t('RecycleGiftCard') }}</span>
    </flex-line>
    <div class="order-wrapper">
      <index-order-item class="order-item" testAttr="GiftBoxList" id="1"
        :src="require('../../../assets/image/member/icon_pay_nor.png')" :title="$t('Verifying')"
        :orderNumber="gift_dot.status_1">
      </index-order-item>
      <index-order-item class="order-item" testAttr="GiftBoxList" id="2"
        :src="require('../../../assets/image/member/icon_goods_nor.png')" :title="$t('Rebuying')"
        :orderNumber="gift_dot.status_2">
      </index-order-item>
      <index-order-item class="order-item" testAttr="GiftBoxList" id="3"
        :src="require('../../../assets/image/member/icon_consignee_nor.png')" :title="$t('Repurchased')"
        :orderNumber="gift_dot.status_3">
      </index-order-item>
      <index-order-item class="order-item" testAttr="GiftBoxList" id="4"
        :src="require('../../../assets/image/member/icon_prices_nor.png')" :title="$t('Paid')"
        :orderNumber="gift_dot.status_4">
      </index-order-item>
    </div> -->

    <div class="tools order">
      <!-- <flex-line class="order-header">
        <span>{{ $t('CommonTools') }}</span>
      </flex-line> -->

      <div class="manage-wrapper">
        <!-- 我的钱包 -->
        <index-manage-item v-on:onclick="goAccount" :src="require('../../../assets/image/member/m1.png')"
          :title="$t('MyWallet')">
        </index-manage-item>
        <!-- 我的账号 -->
        <index-manage-item v-on:onclick="goProfileInfo" :src="require('../../../assets/image/member/m2.png')"
          :title="$t('Personal Info')">
        </index-manage-item>
        <!-- 我的团队 -->
        <index-manage-item v-on:onclick="goMemberInviterManage()" :src="require('../../../assets/image/member/m3.png')"
          :title="$t('MyTeam')">
        </index-manage-item>
        <!-- 我的佣金 -->
        <index-manage-item v-on:onclick="goMyCommission()" :src="require('../../../assets/image/member/m4.png')"
          :title="$t('MyCommission')">
        </index-manage-item>
        <!-- 我的礼品卡 回收记录 -->
        <index-manage-item v-on:onclick="goGiftBoxList" :src="require('../../../assets/image/member/m5.png')"
          :title="$t('GiftCard')">
        </index-manage-item>
        <!-- 我的订单 -->
        <index-manage-item v-on:onclick="goOrder" :src="require('../../../assets/image/member/m6.png')"
          :title="$t('MyOrders')">
        </index-manage-item>
        <!-- 盲盒记录 -->
        <index-manage-item v-on:onclick="goBox" :src="require('../../../assets/image/member/m7.png')"
          :title="$t('BlindBox')">
        </index-manage-item>
        <!-- 更改密码 -->
        <index-manage-item v-on:onclick="onRetrieve" :src="require('../../../assets/image/member/m8.png')"
          :title="$t('Change password')">
        </index-manage-item>
        <!-- 语言选择 -->
        <index-manage-item v-on:onclick="setLang" :src="require('../../../assets/image/member/m9.png')"
          :title="$t('Language selection')">
        </index-manage-item>
        <!-- 我的地址 -->
        <index-manage-item v-on:onclick="goAddress" :src="require('../../../assets/image/member/m10.png')"
          :title="$t('Delivery Address')">
        </index-manage-item>
        <!-- 联系我们 -->
        <index-manage-item v-on:onclick="getEmail" :src="require('../../../assets/image/member/m11.png')"
          :title="$t('Contact us')">
        </index-manage-item>
        <!-- 邀请好友 -->
        <index-manage-item v-on:onclick="getIF" :src="require('../../../assets/image/member/m12.png')"
          :title="$t('Invite friends')">
        </index-manage-item>
        <!-- 注销账号 -->
        <index-manage-item v-on:onclick="signout" :src="require('../../../assets/image/member/m13.png')"
          :title="$t('SignOut')">
        </index-manage-item>

        <!-- <index-manage-item v-on:onclick="goGiftSave" :src="require('../../../assets/image/member/vOrder.png')"
          :title="$t('RecycleGiftCard')">
        </index-manage-item> -->

        <!-- <index-manage-item v-on:onclick="goBrowse()" :src="require('../../../assets/image/member/hist.png')"
          :title="$t('BrowsingHistory')">
        </index-manage-item> -->


        <!-- 退出 -->
        <!-- <index-manage-item v-on:onclick="logout" :src="require('../../../assets/image/member/tc.png')"
          :title="$t('Log Out')">
        </index-manage-item> -->

        <!-- <index-manage-item v-on:onclick="goMemberInviterManage()"
          :src="require('../../../assets/image/member/refunds.png')" title="E-mail">
        </index-manage-item> -->
        <!-- <index-manage-item v-if="config && config.instant_message_open == '1' && config.instant_message_gateway_url"
          v-on:onclick="goMemberChatList" :src="require('../../../assets/image/member/icon_list_pre.png')"
          :title="$t('ChatList')">
        </index-manage-item>
        <index-manage-item v-if="config && config.member_auth == '1'" v-on:onclick="$router.push({ name: 'MemberAuth' })"
          :src="require('../../../assets/image/member/icon_testimony_pre.png')" :title="$t('RealNameVerification')">
        </index-manage-item> -->
        <!-- <index-manage-item v-on:onclick="goMemberFeedback()"
          :src="require('../../../assets/image/member/icon_feedback_pre.png')" title="Feedback">
        </index-manage-item>
        <index-manage-item v-on:onclick="goVrOrder" :src="require('../../../assets/image/member/icon_order_pre.png')"
          :title="$t('VirtualOrders')">
        </index-manage-item>
        <index-manage-item v-on:onclick="goReturn" :src="require('../../../assets/image/member/icon_refund_pre.png')"
          :title="$t('Refunds')">
        </index-manage-item>
        <index-manage-item v-on:onclick="goFriendList" :src="require('../../../assets/image/member/icon_friend_pre.png')"
          :title="$t('MyFriends')">
        </index-manage-item>
        <index-manage-item v-on:onclick="goFavourite()"
          :src="require('../../../assets/image/member/icon_collect_pre.png')" :title="$t('MyFavorites')">
        </index-manage-item>
        <index-manage-item v-on:onclick="$router.push({ name: 'MemberConsultList' })"
          :src="require('../../../assets/image/member/icon_consult_pre.png')" title="咨询管理">
        </index-manage-item>
        <index-manage-item v-on:onclick="$router.push({ name: 'MemberInformList' })"
          :src="require('../../../assets/image/member/icon_offence_pre.png')" title="举报管理">
        </index-manage-item>
        <index-manage-item v-on:onclick="$router.push({ name: 'MemberComplaintList' })"
          :src="require('../../../assets/image/member/icon_propose_pre.png')" title="投诉管理">
        </index-manage-item>
        <index-manage-item v-on:onclick="goInvoice" :src="require('../../../assets/image/member/icon_invoice_pre.png')"
          title="发票管理">
        </index-manage-item>
        <index-manage-item v-on:onclick="goEvaluateList()"
          :src="require('../../../assets/image/member/icon_judgea_pre.png')" :title="$t('MyReviews')">
        </index-manage-item>
        <index-manage-item v-on:onclick="goArrivalnotice()"
          :src="require('../../../assets/image/member/icon_notify_pre.png')" title="Arrival Notifications">
        </index-manage-item> -->

      </div>
    </div>
    <div class="" style="margin: .6rem 3.6rem;">
      <div class="common-btn ds-button-large" @click="logout">{{ $t('Log Out') }}</div>
    </div>

    <!-- <flex-line class="order-header">
      <span>我的活动</span>
    </flex-line>
    <div class="manage-wrapper">
      <index-manage-item v-on:onclick="goMarketmanagelog()"
        :src="require('../../../assets/image/member/icon_exercise_pre.png')" title="活动记录">
      </index-manage-item>
      <index-manage-item v-on:onclick="gBargain()" :src="require('../../../assets/image/member/icon_bargain_pre.png')"
        title="砍价活动">
      </index-manage-item>
      <index-manage-item v-if="config.points_isuse === '1' && config.points_signin_isuse === '1'"
        v-on:onclick="$router.push({ name: 'MemberPointSignin' })"
        :src="require('../../../assets/image/member/icon_signin_pre.png')" title="我要签到">
      </index-manage-item>
      <index-manage-item v-if="config.inviter_open === '1'" v-on:onclick="goMemberInviterManage()"
        :src="require('../../../assets/image/member/icon_popularize_pre.png')" title="推广管理">
      </index-manage-item>
    </div> -->

    <!-- 店舖管理
    <div class="bottom-wrapper">
      <flex-line v-if="user.store_id" @click.native="goSellerInfo" :is-link="true">
        <img class="item-icon" src="../../../assets/image/member/icon_shop_seller_nor.png" />
        <span>{{ $t('StoreManagement') }}</span>
      </flex-line>
      <div v-else>
        <flex-line v-if="config && config.store_joinin_open != 0" @click.native="goSellerJoinin" :is-link="true">
          <img class="item-icon" src="../../../assets/image/member/icon_shop_seller_nor.png" />
          <span>{{ $t('BecomeASeller') }}</span>
        </flex-line>
      </div>
    </div> -->

    <!-- <guess-like></guess-like> -->
    <audio src="../../../assets/image/gobuy/44s.mp3" muted style="display: none;"></audio>
    <audio src="../../../assets/image/gobuy/15s.mp3" muted style="display: none;"></audio>
  </div>
</template>

<script>
import IndexOrderItem from './IndexOrderItem'
import IndexManageItem from './IndexManageItem'
import flexLine from '../../flexLine'
import GuessLike from '../../GuessLike'
import { mapState, mapActions, mapMutations } from 'vuex'
import { getMemberIndex, boxList, giftList, get_config } from '../../../api/member'
import { logout, signout, getMemberInfo } from '../../../api/member'
import { checkInviter } from '../../../api/memberInviter'
import { Toast, MessageBox } from 'mint-ui'
export default {
  name: 'MemberIndex',
  data() {
    return {
      user: {},
      time: '',
      orderCount: {},
      isShow: true,
      box_dot: {},  //盲盒徽标
      gift_dot: {},  //礼品卡徽标
      email_to: ''
    }
  },
  components: {
    flexLine,
    IndexOrderItem,
    IndexManageItem,
    GuessLike
  },
  created: function () {
    this.utils.preloadImages(['https://ysmhh.s3.amazonaws.com/1.gif', 'https://ysmhh.s3.amazonaws.com/2.gif'])



    this.time = new Date().getTime()
    this.fetchConfig({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
    if (this.isOnline) {
      boxList().then(
        response => {
          if (response && response.result) {
            this.box_dot = response.result
          }
        },
        error => { }
      )
      giftList().then(
        response => {
          if (response && response.result) {
            this.gift_dot = response.result
          }
        },
        error => { }
      )

      getMemberIndex().then(
        response => {
          if (response && response.result.member_info) {
            this.user = response.result.member_info
          }
        },
        error => { }
      )
    }
  },
  computed: {
    ...mapState({
      isOnline: state => state.member.isOnline,
      config: state => state.config.config
    }),

    nickname() {
      let title = '登录/注册'
      if (this.isOnline) {
        if (
          this.user &&
          typeof this.user !== 'undefined' &&
          JSON.stringify(this.user) !== '{}'
        ) {
          title = this.user.member_nickname
        }
      }
      return title
    },
    getScore() {
      let score = '0'
      if (this.isOnline && this.user.member_points) {
        score = this.user.member_points
      }
      return score
    },
    // 预存款可用金额 通过store 进行获取
    getAvailablePredeposit() {
      let availablePredeposit = '0.00'
      if (this.isOnline && this.user.available_predeposit) {
        availablePredeposit = this.user.available_predeposit
      }
      return availablePredeposit
    },
    getlevelname() {
      let levelname = ''
      if (this.isOnline && this.user.level_name) {
        levelname = this.user.level_name
      }
      return levelname
    }
  },
  methods: {
    ...mapActions({
      fetchConfig: 'fetchConfig',
    }),
    ...mapMutations({
      memberLogout: 'memberLogout',
    }),
    getEmail() {
      this.$router.push({ name: 'MemberContactUs' })
    },
    getIF() {
      this.$router.push({ name: 'MemberInviteFriends' })
    },
    signout() {
      this.$router.push({ name: 'MemberSignOut' })
    },
    logout() {
      logout(this.user.member_name).then(res => {
        this.memberLogout()
        this.$router.push({ name: 'HomeMemberLogin' })
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    showLogin() {
      this.$router.push({ name: 'HomeMemberLogin' })
    },
    goScoreList() {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberPointList', query: { index: 0 } })
      } else {
        this.showLogin()
      }
    },
    goOrder() {
      if (this.isOnline) {
        this.$router.push({
          name: 'MemberOrderList'
        })
      } else {
        this.showLogin()
      }
    },
    goBox() {
      if (this.isOnline) {
        this.$router.push({
          name: 'BlindBoxList'
        })
      } else {
        this.showLogin()
      }
    },
    setLang() {
      this.$router.push({ name: 'HomeLang' })
    },
    onRetrieve() {
      // this.$router.push({ name: 'HomeMemberForget' })
      this.$router.push({ name: 'MemberChangePassword' })
    },
    goGiftBoxList() {
      if (this.isOnline) {
        this.$router.push({
          name: 'GiftBoxList'
        })
      } else {
        this.showLogin()
      }
    },
    goGiftSave() {
      if (this.isOnline) {
        this.$router.push({
          name: 'GiftSave'
        })
      } else {
        this.showLogin()
      }
    },
    goProfileInfo() {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberProfileSet' })
      } else {
        this.showLogin()
      }
    },
    goSetting() {
      this.$router.push({ name: 'MemberSetting' })
    },
    // 消息通知
    goNews() {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberNoticeList' })
      } else {
        this.showLogin()
      }
    },
    // 我的关注
    goFavourite() {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberFavorite' })
      } else {
        this.showLogin()
      }
    },
    // 我的地址
    goAddress() {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberAddressList' })
      } else {
        this.showLogin()
      }
    },
    // 我的退款
    goReturn() {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberOrderreturn' })
      } else {
        this.showLogin()
      }
    },
    goAccount() {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberAccount' })
      } else {
        this.showLogin()
      }
    },
    goCommission(e) {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberCommission', query: { indexe: e } })
      } else {
        this.showLogin()
      }
    },
    goPredeposit() {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberPredepositList' })
      } else {
        this.showLogin()
      }
    },
    // 我的好友列表
    goFriendList() {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberFriendList' })
      } else {
        this.showLogin()
      }
    },
    // 商家入驻
    goSellerJoinin() {
      if (this.isOnline) {
        this.$router.push({ name: 'SellerJoinin1' })
      } else {
        this.showLogin()
      }
    },
    // 聊天列表
    goMemberChatList() {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberChatList' })
      } else {
        this.showLogin()
      }
    },
    // 我的订单评价
    goEvaluateList() {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberEvaluateList' })
      } else {
        this.showLogin()
      }
    },
    // 发票管理
    goInvoice() {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberInvoiceList' })
      } else {
        this.showLogin()
      }
    },
    // 跳转卖家管理中心
    goSellerInfo() {
      if (this.isOnline) {
        this.$router.push({ name: 'SellerIndex' })
      } else {
        this.showLogin()
      }
    },
    // 分销管理中心
    goMemberInviterManage() {
      if (this.isOnline) {
        checkInviter().then(res => {
          this.$router.push({ name: 'MemberInviterManage' })
        }).catch(function (error) {
          Toast(error.message)
        })
      } else {
        this.showLogin()
      }
    },
    goMyCommission() {
      if (this.isOnline) {
        checkInviter().then(res => {
          this.$router.push({ name: 'MemberCommission' })
        }).catch(function (error) {
          Toast(error.message)
        })
      } else {
        this.showLogin()
      }
    },
    // 意见反馈
    goMemberFeedback() {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberFeedback' })
      } else {
        this.showLogin()
      }
    },
    // 虚拟订单
    goVrOrder() {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberVrOrderList' })
      } else {
        this.showLogin()
      }
    },
    // 活动记录
    goMarketmanagelog() {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberMarketmanagelog' })
      } else {
        this.showLogin()
      }
    },
    // 砍价活动
    gBargain() {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberBargainlist' })
      } else {
        this.showLogin()
      }
    },
    // 到货通知
    goArrivalnotice() {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberArrivalnotice' })
      } else {
        this.showLogin()
      }
    },
    // 浏览历史
    goBrowse() {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberBrowseList' })
      } else {
        this.showLogin()
      }
    },
    gotobuy() {
      this.$router.push({ name: 'HomeGoBuy' })
    },
  }
}
</script>

<style scoped lang="scss">
.container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  background-color: #F9F9F9;
  text-align: center;
  padding-bottom: 3rem;

  .top-wrapper {
    position: relative;
    height: 11rem;
    background-image: url("../../../assets/image/member/bg_wode_com.png");
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: 100% -60%;

    .top-info-wrapper {
      flex: 1;
      width: 100%;
      text-align: center;
      margin-top: 2rem;
    }
  }

  .nav-item {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 1.2rem;

    span {
      width: 0.4rem;
      height: 0.4rem;
      background-color: #f0f2f5;
      border-radius: 50%;
      position: absolute;
      top: 0.5rem;
      right: 0.5rem;
    }
  }

  #left-nav-item {
    left: 0.7rem;
  }

  #right-nav-item {
    right: 0.7rem;
  }

  .nav-icon {
    width: 1rem;
    height: 1rem;
    text-align: center;
    color: #fff;
  }

  .avatar-wrapper {
    position: relative;
    width: 6rem;
    height: 6rem;
    border-radius: 50%;
    background-color: #fff;
    margin: 0 auto;
    margin-top: 1rem;

    .avatar {
      width: 5rem;
      height: 5rem;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .nickname {
    width: 100%;
    margin-top: 0.75rem;
    font-size: 24px;
    font-weight: 600;
    color: rgb(0, 0, 0);
    text-align: center;
    margin-left: 0;
    margin-right: 0;
  }

  .uid {
    margin-top: 0.15rem;
    font-size: 15px;
    color: #7C7C7C;
  }

  .level_name_wrapper {
    font-size: .6rem;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    margin-left: 0;
    margin-right: 0;
    border-radius: .2rem;
    border: 1px solid #fff;
    display: inline-block;
    padding: 0.1rem .2rem;
  }

  .level_name {
    display: flex;
    align-items: center;
  }

  .levelname-icon {
    width: 1rem;
    height: .6rem;
    padding-right: .2rem;
  }

  .info-wrapper {
    position: absolute;
    bottom: -5.5rem;
    left: 1.5rem;
    right: 1.5rem;
    padding: 10px;
    display: inline-flex;
    flex-direction: row;
    justify-content: flex-start;
    align-content: stretch;
    background-color: #fff;
    border-radius: .4rem;
    box-shadow: 0px 4px 4px #f7f7f7;
    z-index: 2;
  }

  .info-item {
    flex: 1;
    text-align: center;
    font-size: $h2;
    color: #7F7F7F;
    position: relative;

    &:first-child::after {
      // content: '';
      position: absolute;
      top: .5rem;
      bottom: .5rem;
      right: 0;
      border-right: 1px dashed #eee;
    }

    .item {
      padding-top: .5rem;
    }

    .price {
      color: #FB2933;
      padding-bottom: .5rem;
      font-weight: 600;
    }
  }

  .order-header {
    background-color: #fff;
    padding: 0 $pageSpace;
    margin-top: $modelSpace;
  }

  .item-title {
    font-size: $subFontSize;
    color: $formInputColor;
    font-weight: 700;
  }

  .order-subtitle {
    font-size: $fontSize;
    color: $descTextColor;
  }

  .order {
    margin: 12px 25px;
    padding: 8px 12px;
    background: #fff;
    border-radius: 10px;

    .order-header {
      margin: 0 0 1rem 0;
      padding: 0;
      min-height: auto;
    }
  }

  .order-wrapper {
    padding: 10px 0;
    // height: 4rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
    background-color: #fff;
  }

  .order-item {
    flex: 1;
  }

  .bottom-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    margin-top: $modelSpace;
    margin-bottom: $modelSpace;
    background: #fff;
    padding: 0 $pageSpace;

    .item-icon {
      width: 1.2rem;
      height: 1.2rem;
      margin-right: .4rem;
    }
  }

  .manage-wrapper {
    background: #fff;
  }
}

.banner {
  margin: 6rem 25px 10px;

  img {
    width: 100%;
    height: 100%;
  }
}
</style>
